module.exports = __webpack_public_path__ + "71292818.png";